import type { CSSProperties, ReactNode } from 'react';
import { Icon, type IconName } from '@/components/foundations';

export type NoticeProps = {
  /** `ok` é o aviso verde do pacote; `warn`/`err` usam só tokens existentes. */
  tone?: 'ok' | 'warn' | 'err';
  icon?: IconName;
  /** Ícone decorativo à direita. */
  trailingIcon?: IconName;
  action?: ReactNode;
  children: ReactNode;
};

const TONE: Record<'warn' | 'err', CSSProperties> = {
  warn: { borderColor: 'var(--gold-line)', background: 'var(--gold-soft)' },
  err: { borderColor: 'var(--red-line)', background: 'var(--red-soft)' },
};
const ICON_COLOR = { warn: 'var(--gold-d)', err: 'var(--red)' } as const;
const DEFAULT_ICON = { ok: 'checkc', warn: 'alert', err: 'x' } as const;

/** Aviso com ícone (`.notice`), ex.: "Parabéns! Suas vendas cresceram…". */
export function Notice({ tone = 'ok', icon = DEFAULT_ICON[tone], trailingIcon, action, children }: NoticeProps) {
  return (
    <div className="notice" role="status" style={tone === 'ok' ? undefined : TONE[tone]}>
      <Icon name={icon} style={tone === 'ok' ? undefined : { color: ICON_COLOR[tone] }} />
      <span>{children}</span>
      {action}
      {trailingIcon && <Icon name={trailingIcon} />}
    </div>
  );
}
